import { EventBasedTransport } from '@codefluegel/lazy-loading-key-value-store';
import {
  News,
  FireSafetyEntry,
  VideoCategory,
  Video,
  MaexchenUserData,
  MaexchenCollectCredit,
  MaexchenRedeemCredit,
  MaexchenRedeemProducts,
  UserData,
} from '../types/transport';
import NewsStore from './NewsStore';
import AuthStore from './AuthStore';
import ConfigStore from './ConfigStore';
import FireSafetyStore from './FireSafetyStore';
import VideoCategoryStore from './VideoCategoryStore';
import UserStore from './UserStore';
import VideoStore from './VideoStore';
import { UserDataChangedCallback } from '../firebaseConnection/authentication';
import RedeemProductStore from './RedeemProductStore';

export type RootStoreOpts = {
  roleStorePersistanceKey?: string;
  newsStoreTransport?: EventBasedTransport<News>;
  fireSafetyStoreTransport?: EventBasedTransport<FireSafetyEntry>;
  videoCagegoryTransport?: EventBasedTransport<VideoCategory>;
  videoTransport?: EventBasedTransport<Video>;
  userStoreTransport?: EventBasedTransport<MaexchenUserData>;
  configStoreTransport?: EventBasedTransport<string | number>;
  registerAuthChanged?: (callback: UserDataChangedCallback) => unknown;
  redeemProductsTransport?: EventBasedTransport<MaexchenRedeemProducts>;

  collectedPointsTransportFactory?: (
    groupId: string,
  ) => EventBasedTransport<MaexchenCollectCredit>;
  redeemedPointsTransportFactory?: (
    groupId: string,
  ) => EventBasedTransport<MaexchenRedeemCredit>;
  getUserDataTransport?: (uid: string) => Promise<UserData>;
};

export default class RootStore {
  public newsStore?: NewsStore;

  public configStore?: ConfigStore;

  public authStore?: AuthStore;

  public fireSafetyStore?: FireSafetyStore;

  public videoStore?: VideoStore;

  public userStore?: UserStore;

  public videoCategoryStore?: VideoCategoryStore;

  public redeemProductStore?: RedeemProductStore;

  constructor(opts: RootStoreOpts) {
    if (opts.newsStoreTransport) {
      this.newsStore = new NewsStore(opts.newsStoreTransport);
    }
    if (opts.configStoreTransport) {
      this.configStore = new ConfigStore(opts.configStoreTransport);
    }
    if (opts.fireSafetyStoreTransport) {
      this.fireSafetyStore = new FireSafetyStore(opts.fireSafetyStoreTransport);
    }
    if (opts.videoTransport) {
      this.videoStore = new VideoStore(opts.videoTransport);
    }
    if (
      opts.userStoreTransport &&
      opts.collectedPointsTransportFactory &&
      opts.redeemedPointsTransportFactory &&
      opts.getUserDataTransport
    ) {
      this.userStore = new UserStore(
        opts.userStoreTransport,
        opts.collectedPointsTransportFactory,
        opts.redeemedPointsTransportFactory,
        opts.getUserDataTransport,
      );
    }
    if (opts.videoCagegoryTransport) {
      this.videoCategoryStore = new VideoCategoryStore(
        opts.videoCagegoryTransport,
      );
    }
    if (opts.registerAuthChanged) {
      this.authStore = new AuthStore(opts.registerAuthChanged);
    }
    if (opts.redeemProductsTransport) {
      this.redeemProductStore = new RedeemProductStore(
        opts.redeemProductsTransport,
      );
    }
  }
}
